// extracted by mini-css-extract-plugin
export var container = "Container-module__container___yXF4x";